import { get } from '../utils'
import {getActiveChannel, getActiveClient} from "../authentication/utils";

const url = (host, type, tags, notTags, search= "") =>
  `${host}/clients/${getActiveClient()}/channels/${getActiveChannel()}/contentCreationsIds?category=${type}${(tags && tags.length > 0) ? `&tags_ids=${tags.join(',')}` : ''}${(notTags && notTags.length > 0) ? `&not_tags_ids=${notTags.join(',')}`: ''}${search ? `&name=${search}` : ''}&active=1`;

export default host => (type, tags, notTags, search= "") =>
  get(url(host, type, tags, notTags, search))
    .then(response => response.json())